<template>
  <div id="footer" class="container-fluid">
    <div class="logo">
      <!-- <img src="@/assets/img/logo.png" alt="logo图"> -->
    </div>

    <p class="title">北京奥盛企业管理咨询有限公司</p>
    <p class="email_wx">
      <span>联系电话：400-666-5536</span>
    </p>
    <p class="email_wx">
      <span>aoshengcaijing@163.com</span>
    </p>

    <p class="address_tel_fax">
      <span>地址：北京市西城区恒华商务中心</span>
    </p>
    <p class="copy">
      Copyright &copy; 2018 - {{ new Date().getFullYear() }} 北京奥盛企业管理咨询有限公司 <span style="margin-left: 1rem;">京ICP备2025150713号-1</span>
    </p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  },
  methods: {
    isPageHidden() {
      const hideList = ["bigData", "jobchance"];
      const currentPath = window.location.hash;

      if (!currentPath) return false;

      // 提取路径中的关键标识，兼容 hash 路由和查询参数
      // 例如: '#/software/bigData?type=1' -> 'bigData'
      // 例如: '/home/jobchance' -> 'jobchance'
      const pathParts = currentPath.split("/");
      const lastSegment = pathParts[pathParts.length - 1];
      const pageKey = lastSegment ? lastSegment.split("?")[0].split("#")[0] : "";

      return hideList.includes(pageKey);
    },
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 95px;
  height: 45px;
  /* margin: 30px auto 20px; */
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {
    font-size: 12px;
  }
  .copy {
    font-size: 12px;
    margin: 30px 0 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue